<h2 mat-dialog-title>Invite User</h2>
<form [formGroup]="form" (ngSubmit)="submit()">
  <mat-dialog-content class="flex flex-col gap-4">
    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Account</mat-label>
      <input matInput formControlName="account_id" />
    </mat-form-field>

    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Email</mat-label>
      <input matInput type="email" formControlName="email" autocomplete="off" />
      <mat-error *ngIf="form.get('email').hasError('required')">
        Required
      </mat-error>
      <mat-error *ngIf="form.get('email').hasError('email')">
        Invalid email
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Role</mat-label>
      <mat-select formControlName="role">
        <mat-option *ngFor="let r of roleOptions" [value]="r">
          {{ r | snakeCaseSplit | titlecase }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('role').hasError('required')">
        Required
      </mat-error>
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button
      mat-flat-button
      color="primary"
      type="submit"
      [disabled]="form.invalid"
    >
      Send Invitation
    </button>
  </mat-dialog-actions>
</form>
